module.exports = __webpack_public_path__ + "img/resource_side_by_side.28eb5b2e.png";